import { render, staticRenderFns } from "./GameLeaderboardReport.vue?vue&type=template&id=620f6678"
import script from "./GameLeaderboardReport.vue?vue&type=script&lang=js"
export * from "./GameLeaderboardReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports